import {Pipe, PipeTransform} from "@angular/core";
import {IdCodeNameModel, IWithDisplayName} from "../models/base-id.model";
import {BaseIdCodeQuery, BaseIdQuery, IdCodeNameQuery} from "../models/base.query";

@Pipe({
  name: 'displayName'
})
export class DisplayNamePipe implements PipeTransform {
  transform(input: IdCodeNameModel | IdCodeNameQuery | BaseIdCodeQuery | IWithDisplayName, nameOnly: boolean = false, codeOnly: boolean = false): string {
    if(input == null){
      return '';
    }

    if (input instanceof IdCodeNameModel || input instanceof IdCodeNameQuery || input instanceof BaseIdCodeQuery) {
      if (input) {
        if (codeOnly) {
          return input.Code;
        }
        if (nameOnly) {
          return input["Name"] ?? input.Code;
        }
        return BaseIdQuery.getDisplayName([input.Code, input['Name']]);
      }
    } else {
      return input?.DisplayName ?? '';
    }
  }
}

